// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorUsage } from './escalator-usage';


export class EscalatorUsageMessage implements flatbuffers.IUnpackableObject<EscalatorUsageMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorUsageMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorUsageMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorUsageMessage):EscalatorUsageMessage {
  return (obj || new EscalatorUsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorUsageMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorUsageMessage):EscalatorUsageMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorUsageMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EscalatorUsage {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EscalatorUsage.Up;
}

static startEscalatorUsageMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EscalatorUsage) {
  builder.addFieldInt16(0, message, EscalatorUsage.Up);
}

static endEscalatorUsageMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEscalatorUsageMessage(builder:flatbuffers.Builder, message:EscalatorUsage):flatbuffers.Offset {
  EscalatorUsageMessage.startEscalatorUsageMessage(builder);
  EscalatorUsageMessage.addMessage(builder, message);
  return EscalatorUsageMessage.endEscalatorUsageMessage(builder);
}

unpack(): EscalatorUsageMessageT {
  return new EscalatorUsageMessageT(
    this.message()
  );
}


unpackTo(_o: EscalatorUsageMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): EscalatorUsageMessageT {
  const t = new EscalatorUsageMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class EscalatorUsageMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EscalatorUsage = EscalatorUsage.Up
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EscalatorUsageMessage.createEscalatorUsageMessage(builder,
    this.message
  );
}

clone(): EscalatorUsageMessageT {
  const obj = new EscalatorUsageMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: EscalatorUsageMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyEscalatorUsageMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
